import React, { createContext, useState,  useContext} from 'react';

const CompletedItemsOnTheTrailContext = createContext();


function CompletedItemsOnTheTrailProvider({ children }) {

  const [ completedItemsOnTrail, setCompletedItemsOnTrail ] = useState([]);

   function loadCompletedItemsOnTrail(items) {

    const completedItemsOnTrailFormatted = items.map(item => {
      return item.item_type + "-" + item.item_id;
    });

    setCompletedItemsOnTrail(completedItemsOnTrailFormatted);
  }


  return (
    <CompletedItemsOnTheTrailContext.Provider value={{ completedItemsOnTrail, loadCompletedItemsOnTrail, setCompletedItemsOnTrail } } >
      { children }
    </CompletedItemsOnTheTrailContext.Provider>
  );
};

function useCompletedItemsOnTheTrail() {
  const context = useContext(CompletedItemsOnTheTrailContext);

  if(!context) {
    throw new Error('useCompletedItemsOnTheTrail must be used within an CompletedItemsOnTheTrailProvider');
  }

  return context;
}

export { CompletedItemsOnTheTrailProvider, useCompletedItemsOnTheTrail };


// WEBPACK FOOTER //
// ./src/hooks/CompletedItemsOnTheTrail.js